import styled from "styled-components";

const Globe = styled.img`
  height: 204px;
  display: block;
  margin-left: auto;
  margin-right: auto;
`;

const Title = styled.div`
  font-weight: bold;
  margin-top: 16px;
  text-align: start;
  font-size: ${(props) => props.theme.font.size.primary};
  color: ${(props) => props.theme.color.text.primary};
`;

const Disclaimer = styled.div`
  font-weight: 600;
  font-size: ${(props) => props.theme.font.size.disclaimer};
  margin-top: 16px;
  color: ${(props) => props.theme.color.text.primary};
`;

const BackgroundButton = styled.div`
  font-weight: 600;
  font-size: ${(props) => props.theme.font.size.disclaimer};
  width: available;
  text-overflow: ellipsis;
  max-lines: 1;
  height: ${(props) => props.theme.coloredButtonHeight.primary};
  text-align: center;
  text-decoration: none;
  border: none;
  line-height: ${(props) => props.theme.coloredButtonHeight.primary};
  margin-top: 16px;
  color: ${(props) => props.theme.color.text.secondary};
  background-color: ${(props) => props.theme.color.accent};
  border-radius: 10px;
  cursor: pointer;

  &:hover {
    cursor: pointer;
    opacity: 90%;
  }
`;

const TextButton = styled.div`
  text-align: center;
  color: ${(props) => props.theme.color.accent};
  font-size: ${(props) => props.theme.font.size.disclaimer};
  font-weight: 600;
  margin-top: 16px;
  cursor: pointer;

  &:hover {
    cursor: pointer;
    opacity: 80%;
  }
`;

export { Globe, Title, Disclaimer, BackgroundButton, TextButton };
